import React from 'react';

const List = ({...props}) => {
  const className = props.className ? ' ' + props.className : '';

  return (
    <ul className={"list" + className}>
      {props.children}
    </ul>
  ) 
}

export default List;